// Older editor links do not have recordsUrl; derive the same scoped endpoint from submitUrl.
export const getRecordUrls = query => {
    if (query.get('hydro') !== '1' || query.get('examMode') === '1') return null;
    try {
        const submit = new URL(query.get('submitUrl'));
        if (!/^https?:$/.test(submit.protocol)) return null;
        const match = /^(.*)\/p\/([^/]+)\/submit\/?$/.exec(submit.pathname);
        if (!match) return null;
        const list = new URL(query.get('recordsUrl') || `${match[1]}/record`, submit);
        const detail = new URL(query.get('resultUrl') || `${match[1]}/record/__RID__`, submit);
        if (list.origin !== submit.origin || detail.origin !== submit.origin) return null;
        if (!list.searchParams.has('pid')) list.searchParams.set('pid', decodeURIComponent(match[2]));
        list.searchParams.set('fullStatus', '1');
        list.searchParams.set('scratchHistory', '1');
        list.searchParams.set('lang', 'scratch3');
        if (submit.searchParams.has('tid')) list.searchParams.set('tid', submit.searchParams.get('tid'));
        if (submit.searchParams.has('trainingTid')) {
            list.searchParams.set('trainingTid', submit.searchParams.get('trainingTid'));
        }
        detail.searchParams.set('inlineResult', '1');
        detail.searchParams.set('includeCaseIO', '1');
        return {list: list.href, detail: detail.href};
    } catch (e) {
        return null;
    }
};

export const getRecordDetailUrl = (urls, rid) => {
    if (!urls || !/^[0-9a-f]{24}$/i.test(rid)) throw new Error('提交记录编号无效');
    return urls.detail.replace('__RID__', rid);
};

export const fetchRecordJSON = async (url, signal) => {
    const response = await fetch(url, {credentials: 'include', headers: {Accept: 'application/json'}, signal});
    const result = await response.json().catch(() => null);
    if (response.status === 401 || !result) throw new Error('登录可能已过期，请返回题目页重新登录后重试');
    if (!response.ok || result.error) throw new Error(result.error?.message || '无法获取提交记录，请稍后重试');
    return result;
};

export const recordStatus = status => ({
    0: '等待评测',
    1: '通过',
    2: '答案错误',
    3: '超出时间限制',
    4: '超出内存限制',
    5: '输出过多',
    6: '运行错误',
    7: '编译错误',
    8: '系统错误',
    9: '已取消',
    20: '评测中',
    21: '编译中',
    22: '正在准备'
}[status] || '评测状态未知');

export const recordTime = rid => (/^[0-9a-f]{24}$/i.test(String(rid)) ?
    new Date(parseInt(rid.slice(0, 8), 16) * 1000).toLocaleString('zh-CN', {hour12: false}) : '时间未知');

export const messageText = message => {
    if (typeof message === 'string') return message;
    if (!message || typeof message.message !== 'string') return '';
    return message.message.replace(/\{(\d+)\}/g, (match, index) =>
        (message.params && typeof message.params[index] !== 'undefined' ? String(message.params[index]) : match));
};

export const caseIOText = (item, field, allowed) => {
    if (allowed === false) return '此记录未开放输入输出详情';
    const value = item.io?.[field];
    if (typeof value === 'string') return value === '' ? '（空）' : value;
    return field === 'actual' ? '此记录未保存实际输出，请重新提交后查看' : '测试数据暂不可用';
};
